<section class="flex flex-row justify-between my-8">
  <span class="font-semibold text-3xl">Hello {{ authUser.given_name }}</span>

  <div class="flex items-center gap-3">
    <p-select
      [options]="portsData()"
      [loading]="portSelectBoxLoading()"
      [(ngModel)]="selectedPort"
      (ngModelChange)="getPortsActivity()"
    >
      <ng-template #dropdownicon>
        <img src="assets/images/filter-icon.png" alt="filter" width="15" />
      </ng-template>
    </p-select>
  </div>
</section>

<section class="grid grid-cols-12 gap-6">
  <!-- Summary Card -->
  <div class="lg:col-span-2 col-span-4">
    <div class="card min-h-[419px]">
      <div class="pl-4 mb-1">
        <span class="text-sm">Selected Port</span>
      </div>
      <div class="pl-4">
        <span class="text-xl font-bold">{{ portsActivityData()?.portCode ?? 'ALL' }}</span>
        <span class="pl-2" *ngIf="portsActivityData()?.isActivityStarter">
          <i
            class="pi pi-question-circle !text-sm"
            [pTooltip]="
              'No activity has been detected for the past ' +
              (portsActivityData()?.daysSinceLastActivity ?? '-') +
              ' days'
            "
          ></i>
        </span>
      </div>

      <div class="pl-4 mt-7 mb-1">
        <span class="text-sm">Users Logged In (Unique)</span>
      </div>
      <div class="pl-4">
        <span class="text-xl font-bold">{{ portsActivityData()?.totalUserCount }}</span>
      </div>

      <div class="pl-4 mt-7 mb-1">
        <span class="text-sm">Total Counter</span>
      </div>
      <div class="pl-4">
        <span class="text-xl font-bold">{{ portsActivityData()?.totalCounterCount }}</span>
      </div>

      <div class="pl-4 mt-7 mb-1">
        <span class="text-sm">Total Activity Time</span>
      </div>
      <div class="pl-4">
        <span class="text-xl font-bold">
          {{ portsActivityData()?.totalActivityTime | duration }}
        </span>
      </div>

      <div class="pl-4 mt-7 mb-2">
        <span class="text-sm">Check-in System</span>
      </div>
      <div class="pl-4">
        @if (portsActivityData()?.checkInSystems?.length === 0) {
          <div class="mb-3">
            <span class="text-sm font-bold">No check-in systems found</span>
          </div>
        } @else {
          @for (system of portsActivityData()?.checkInSystems; track $index) {
            <div class="mb-3">
              <span class="text-sm py-1 px-2 rounded-2xl background-green-opacity">
                {{ system }}
              </span>
            </div>
          }
        }
      </div>
    </div>
  </div>

  <!-- Time-Based Distribution Graph Card -->
  <div class="lg:col-span-10 col-span-8">
    <div class="card">
      <div class="card-header pl-6 pr-6">
        <div class="grid grid-cols-12 items-center">
          <span class="lg:col-span-4 col-span-12 font-bold text-lg">
            Time-Based Distribution of Active {{ selectedApplicationType() | titlecase }}
          </span>

          <div
            class="lg:col-span-8 col-span-12 lg:flex block justify-end items-center gap-4 lg:mt-0 mt-4"
          >
            <div class="flex items-center gap-4">
              <p-floatlabel variant="on" class="!inline-block">
                <app-date-picker-component
                  (onChangeEvent)="onChangeSummaryDateRange($event)"
                  (onCancelEvent)="cancelSummaryDateRange($event)"
                />
                <label for="date_range" class="ml-10">Date Range</label>
              </p-floatlabel>

              @if (getIsSameDay()) {
                <span>|</span>

                <div class="flex items-center gap-3">
                  <p-date-picker
                    inputId="start-time"
                    [(ngModel)]="selectedStartTime"
                    [timeOnly]="true"
                    placeholder="Start Time"
                    class="w-[110px]"
                    (ngModelChange)="onChangeSummaryStartTime($event)"
                    (onClose)="onCloseSummaryStartTime()"
                  />
                  <span>-</span>
                  <p-date-picker
                    inputId="end-time"
                    [(ngModel)]="selectedEndTime"
                    [timeOnly]="true"
                    placeholder="End Time"
                    class="w-[110px]"
                    (ngModelChange)="onChangeSummaryEndTime($event)"
                    (onClose)="onCloseSummaryEndTime()"
                  />
                </div>
              }

              <span>|</span>
            </div>

            <p-select-button
              [(ngModel)]="selectedApplicationType"
              [options]="applicationTypeOptions"
              optionLabel="label"
              optionValue="value"
              [unselectable]="true"
              [allowEmpty]="false"
              (ngModelChange)="onChangeApplicationType()"
              class="lg:mt-0 mt-4"
            />
          </div>
        </div>
      </div>

      <div class="mt-2 px-5">
        @if (selectedApplicationType() === applicationTypeOptions[0].value) {
          @if (isChartFill()) {
            <p-chart
              type="bar"
              [data]="counterChartData()"
              [options]="counterChartOptions()"
              height="340"
            />
          } @else {
            <div class="text-center">No data to display.</div>
          }
        } @else if (selectedApplicationType() === applicationTypeOptions[1].value) {
          @if (isChartFill()) {
            <p-chart
              type="bar"
              [data]="kioskChartData()"
              [options]="kioskChartOptions()"
              height="340"
            />
          } @else {
            <div class="text-center">No data to display.</div>
          }
        }
      </div>
    </div>
  </div>
</section>

<section>
  <p-card styleClass="mt-10 p-2">
    <div class="grid grid-cols-12 gap-6">
      <section class="lg:col-span-8 col-span-12">
        <div class="flex flex-row items-center justify-between">
          <div class="pt-5 pl-4">
            <span class="font-semibold text-xl">Session Details</span>
            <br />
          </div>

          <div class="pt-5 pr-5">
            <p-select-button
              [(ngModel)]="selectedApplicationType"
              [options]="applicationTypeOptions"
              optionLabel="label"
              optionValue="value"
              [unselectable]="true"
              [allowEmpty]="false"
              (ngModelChange)="onChangeApplicationType()"
            />
          </div>
        </div>

        <div class="mt-5 border-t border-r border-gray-200">
          <div
            class="relative"
            *ngIf="selectedApplicationType() === applicationTypeOptions[0].value"
          >
            <div class="absolute top-[10px] left-4 z-10">
              <p-select-button
                [(ngModel)]="selectedCounterStatusType"
                [options]="sessionStatusOptions"
                optionLabel="label"
                optionValue="value"
                [unselectable]="true"
                [allowEmpty]="false"
              />
            </div>
            <app-online-counters-table
              *ngIf="selectedCounterStatusType() === 'online_counter'"
              [selectedPort]="selectedPort()"
            />
            <app-archived-counters-table
              *ngIf="selectedCounterStatusType() === 'archived_counter'"
              [selectedPort]="selectedPort()"
            />
          </div>

          <app-kiosk-table *ngIf="selectedApplicationType() === applicationTypeOptions[1].value" />
        </div>
      </section>

      <!-- URLs connected to port Table - Active Counters Table -->
      <div class="lg:col-span-4 col-span-12 h-full">
        @if (selectedPort() === 'ALL') {
          <div class="pt-5 pl-4">
            <span class="font-semibold text-xl">Active Counters</span>
            <br />
          </div>

          <div class="mt-3 h-full">
            <app-table-component
              [cols]="activeCountersTableCols"
              [data]="activeCounterTablesData()"
              [pagination]="false"
              [loading]="activeCounterTablesLoading()"
              [scrollHeight]="'650px'"
              [searchable]="false"
            />
          </div>
        } @else {
          <div class="pt-5 pl-4">
            <span class="font-semibold text-xl">URLs connected to port</span>
            <br />
          </div>

          <div class="mt-3">
            <app-table-component
              [cols]="urlTableCols"
              [data]="urlTableData() || []"
              [pagination]="false"
              [loading]="urlTableLoading()"
              [scrollHeight]="'650px'"
              [searchable]="false"
            />
          </div>
        }
      </div>
    </div>

    <!-- Templates -->
    <ng-template #statusColumnTemplate let-rowData="rowData">
      <div
        [class]="rowData.serverStatus === 'Offline' ? 'status-indicator error' : 'status-indicator'"
      >
        <div [class]="rowData.serverStatus === 'Offline' ? 'status-dot error' : 'status-dot'"></div>
      </div>
    </ng-template>

    <ng-template #activeColumnTemplate let-rowData="rowData">
      <span class="font-bold">{{ rowData.port }}</span>
    </ng-template>
  </p-card>
</section>
